// extracted by mini-css-extract-plugin
module.exports = {"divRey":"Events_divRey__1ObmJ","contEvents":"Events_contEvents__2_551"};